/**
 * @generated SignedSource<<a4c10fbe1a92470ea5b7eed157380219>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BulkOperationsWrapper$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly issueId: string;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly totalIssueSearchResultCount?: number | null | undefined;
  readonly " $fragmentType": "BulkOperationsWrapper";
};
export type BulkOperationsWrapper$key = {
  readonly " $data"?: BulkOperationsWrapper$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationsWrapper">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BulkOperationsWrapper",
  "selections": [
    {
      "concreteType": "JiraIssueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "issueId"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalIssueSearchResultCount"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "8303be0824c015cc97f6fbaf2b9ceb3c";

export default node;
